export const GET_ACCOUNT_BALANCE = "GET_ACCOUNT_BALANCE";
export const GET_ACCOUNT_BALANCE_SUCCESS = "GET_ACCOUNT_BALANCE_SUCCESS";

export const TRANSFER_FUNDS = "TRANSFER_FUNDS";
export const TRANSFER_FUNDS_SUCCESS = "TRANSFER_FUNDS_SUCCESS";

export const GET_TIP_BALANCE = "GET_TIP_BALANCE";
export const GET_TIP_BALANCE_SUCCESS = "GET_TIP_BALANCE_SUCCESS";
